import React, { useState } from 'react'
import Tabs from './Tabs'

export default function IndependentTabs (props) {

  const [selectedTab, setSelectedTab] = useState(0)

  const handleTabChange = (tabIndex) => {
    setSelectedTab(tabIndex)
  }

  return <Tabs {...props}
               selectedTab={selectedTab}
               onSelectedTabChange={handleTabChange}/>
}
